module.exports = __webpack_public_path__ + "static/img/done.aedbae0.png";